import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import {
  isWeixin
} from "@utils";
import {
  oAuth
} from "@utils/wechat";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  let fullPath = location.pathname + location.hash
  cookie.set("login_back_url", backUrl || fullPath);
  if (isWeixin()) {
    oAuth();
  }
}



// WEBPACK FOOTER //
// ./src/utils/login.js